// The Monetization tab of a club / athlete cabinet: AP balance, withdrawal
// requests (handled by Arena managers, no blockchain) and the AP fans bring.
// USDT come as micro-USDT; the rate is micro-USDT per 1 AP.

export type ClubFinance = {
  total_earned_ap: number
  pending_ap: number
  balance_ap: number
  rate_micro_usdt: number
  min_withdrawal_ap: number
}

export type WithdrawalStatus = 'pending' | 'completed' | 'canceled'

export type ClubWithdrawal = {
  id: string
  amount_ap: number
  usdt_micro: number
  status: WithdrawalStatus
  created_at: string
}

export type FanIncomeItem = {
  id: string
  earned_ap: number
  earned_at: string
  fan: {
    user_id: string
    name: string
    avatar_url?: string
    country_iso2?: string
    country_name?: string
  }
  task: {
    id: string
    title: string
    type: string
    platform?: string
    brand_name?: string
    brand_logo_url?: string
  }
}

export type FanIncomePage = { items: FanIncomeItem[]; next_cursor: string }

export const FAN_INCOME_PLATFORMS = [
  'youtube',
  'tiktok',
  'instagram',
  'facebook',
  'x'
] as const

const MICRO = 1_000_000

/** USDT for `amountAp` at the rate, rounded down to a cent. */
export function usdtFor(amountAp: number, rateMicroUsdt: number): number {
  return Math.floor((amountAp * rateMicroUsdt) / (MICRO / 100)) / 100
}

export const microToUsdt = (micro: number) => micro / MICRO

/** Why a request can't be sent, or null when it can. */
export function withdrawalAmountError(
  amount: number,
  finance: Pick<ClubFinance, 'balance_ap' | 'min_withdrawal_ap'>
): 'empty' | 'belowMin' | 'aboveBalance' | null {
  if (!Number.isInteger(amount) || amount <= 0) {
    return 'empty'
  }
  if (amount < finance.min_withdrawal_ap) {
    return 'belowMin'
  }
  if (amount > finance.balance_ap) {
    return 'aboveBalance'
  }
  return null
}
